/**
 * Environment-based configuration for Al Mamzar Car Wash
 * Automatically detects environment and provides appropriate settings
 */

const getEnvironment = () => {
  // Check if we're in production build
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  
  // Check if running on production domain (for client-side detection)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'almamzarcarwash.com' || hostname.includes('almamzarcarwash.com')) {
      return 'production';
    }
  }
  
  // Default to development
  return 'development';
};

const config = {
  development: {
    apiUrl: 'http://localhost:3001',
    protocol: 'http',
    environment: 'development'
  },
  production: {
    apiUrl: 'https://almamzarcarwash.com:3001',
    protocol: 'https',
    environment: 'production'
  }
};

const currentEnv = getEnvironment();
const currentConfig = config[currentEnv];

// Export configuration
export const API_BASE_URL = currentConfig.apiUrl;
export const PROTOCOL = currentConfig.protocol;
export const ENVIRONMENT = currentConfig.environment;

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Log current configuration (for debugging)
console.log(`🔧 Environment: ${ENVIRONMENT}`);
console.log(`🌐 API Base URL: ${API_BASE_URL}`);

export default currentConfig;